import script from "./dashboard-page.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard-page.vue?vue&type=script&setup=true&lang=js"

import "./dashboard-page.vue?vue&type=style&index=0&id=a612b450&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a612b450"]])

export default __exports__